import {initAutoScroll, initSplide} from "./vendor/splide";
import siteVars from "./utils/utils";

export class Frontpage {
    constructor() {
        if (!$('body').hasClass('home')) return;
        this.eventHandlers();
        initAutoScroll();
    }

    eventHandlers() {

    }
}